/** Capture health for the state line (spec §7.3: shown only when learning broke, with one action). */
import { useCallback, useEffect, useState } from "react";
import { getCaptureHealth, retryFailedCaptures } from "@/api/memory";
export function useLearningHealth(): {
  failed: number;
  retrying: boolean;
  retry: () => void;
} {
  const [failed, setFailed] = useState(0);
  const [retrying, setRetrying] = useState(false);
  const load = useCallback(
    () =>
      getCaptureHealth().then(
        (health) => setFailed(health.failed_count),
        () => undefined,
      ),
    [],
  );
  useEffect(() => {
    void load();
  }, [load]);
  const retry = useCallback(() => {
    setRetrying(true);
    void retryFailedCaptures()
      .then(load, () => undefined)
      .finally(() => setRetrying(false));
  }, [load]);
  return { failed, retrying, retry };
}
